// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__pED5j","clinicsSelect":"TableHeading_clinicsSelect__3N2Mm"};